import { configureStore, combineReducers } from '@reduxjs/toolkit';
import * as allReducers from './reducers';
import history from './apphistory';
import StateManager from 'utilities/state';
import allMiddleware from './state';
import { createLogger } from 'redux-logger';

const loggerMiddleware = createLogger({
    collapsed: (getState, action, logEntry) => !logEntry.error
});

// eslint-disable-next-line no-undef
const isDevelopment = process.env.NODE_ENV === 'development';

const rootReducer = combineReducers({
    ...allReducers
});

const stateManager = new StateManager();

stateManager.applyMiddleware(allMiddleware);

export default async function () {

        const initialState = await stateManager.initialiseState();

        const store = configureStore({
            reducer: rootReducer,
            middleware: getDefaultMiddleware => {

                const middleware = getDefaultMiddleware();

                if (isDevelopment) {
                    middleware.push(loggerMiddleware);
                }
                return middleware;
            },
            devTools: isDevelopment,
            preloadedState: initialState
        });

        store.subscribe(async () => await stateManager.onStateChanged(store.getState()));

        // store.history = history;
  
    return store;
}